import { render, staticRenderFns } from "./UserProfileView.vue?vue&type=template&id=43700cfc&scoped=true"
import script from "./UserProfileView.ts?vue&type=script&lang=ts&external"
export * from "./UserProfileView.ts?vue&type=script&lang=ts&external"
import style0 from "./UserProfileView.scss?vue&type=style&index=0&id=43700cfc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43700cfc",
  null
  
)

export default component.exports